/** Testimonial corpus — C09: confirm publication permission before public launch. */
export const testimonials = [
  {
    id: 'kaye-simmons',
    text: 'Our students really enjoyed the Soccer STEM Club after school with footyLab Founder and Director, Coach Gus. The students were able to pair their love of playing soccer with real world technology applications in our Fab Lab. Using the pro level GPS trackers to gather and analyze their own performance data extended their tech knowledge and skills and gave them a glimpse into the future and the possibilities for various careers in sports. I highly recommend this program.',
    author: 'Kaye Simmons',
    title: 'Principal',
    organization: "Tate's School",
  },
  {
    id: 'chace-mom',
    text: 'I just wanted to take a minute and send you an email on how appreciative I am of you and the school offering the STEM soccer club. What a unique and FUN way to build a love of data science skills! Being able to play soccer with their friends after school and then going into the computer lab and uploading and analyzing their performance data together and building a web app was such an amazing opportunity and one I hope you can bring back again. Chace learned so much and loved every minute of it. Please tell Coach Gus we appreciate him doing this so much and he did a fabulous job and we would love to participate in this program again.',
    author: "Chace's Mom",
  },
  {
    id: 'denise-dean',
    text: 'Gustavo worked with our scholars at East TN Freedom Schools this past summer. He is knowledgeable about soccer & IT. He is thoughtful and easy to work with. He created a positive and engaging experience for our scholars. Gustavo cultivated positive working relationships with our staff and scholars. The project he built and offered worked so well we want to work with him again.',
    author: 'Denise Dean',
    title: 'Executive Director',
    organization: 'East Tennessee Freedom Schools',
  },
  {
    id: 'teddy-dad',
    text: "The camp introduced a new way of thinking about his performance on the field. There's been a shift from qualitative to quantitative. He now talks about metrics like speed and distance on top of goals and assists. Every day I picked him up he was smiling and was excited to tell me about the matches and how they played with the data. It also added some ownership of the data since he was not just being told what happened, but was a part of the process. Thanks One Knox for providing these types of opportunities!",
    author: "Teddy's Dad",
  },
  {
    id: 'evie-mom',
    text: 'My daughter really enjoyed her Soccer/STEM experience!  It was fun and an appropriate skill level for a variety of ages and relating real world technologies to her favorite sport is so great, lets her know there are many different ways to have careers in sports!',
    author: "Evie's Mom",
  },
  {
    id: 'garrison-mom',
    text: 'My son and I went over his stats in great detail and how it relates to his gameplay. It has not only ignited his interest in leveraging the data to become a better player, but also has him asking about how this methodology can be used in other areas of his life such as his grades and how they relate to test score, homework, extra credit, etc. He truly has become fascinated with data and how it correlates with the world around him thanks to Gustavo.',
    author: "Garrison's Mom",
  },
];

/** Curated Home display (WD-04). */
export const homeTestimonialIds = ['kaye-simmons', 'denise-dean', 'garrison-mom'];

export const getTestimonialsByIds = (ids) =>
  ids
    .map((id) => testimonials.find((item) => item.id === id))
    .filter(Boolean);
